import translationEN from '../../assets/languages/en.json'
import translationNL from '../../assets/languages/nl.json'

import translationBN from '../../assets/languages/bn.json'
import translationDE from '../../assets/languages/de.json'
import translationES from '../../assets/languages/es.json'
import translationFR from '../../assets/languages/fr.json'

import translationIT from '../../assets/languages/it.json'
import translationJA from '../../assets/languages/ja.json'
import translationPT from '../../assets/languages/pt.json'
import translationRU from '../../assets/languages/ru.json'

import translationVI from '../../assets/languages/vi.json'
import translationZH from '../../assets/languages/zh.json'

export const translationResource = {
  en: {
    translation: translationEN,
  },
  nl: {
    translation: translationNL,
  },
  bn: {
    translation: translationBN,
  },
  de: {
    translation: translationDE,
  },
  es: {
    translation: translationES,
  },
  fr: {
    translation: translationFR,
  },
  it: {
    translation: translationIT,
  },
  ja: {
    translation: translationJA,
  },
  pt: {
    translation: translationPT,
  },
  ru: {
    translation: translationRU,
  },
  vi: {
    translation: translationVI,
  },
  zh: {
    translation: translationZH,
  },
}
